import React from 'react'
import HomeHero from './HomeHero'
import HomeAbout from './HomeAbout'
import HomeServices from './HomeServices'
import Section1 from './Section1'
import ContactForm from './ContactForm'
import Testimonials from './Testimonials'
import OurProduct from './OurProduct'

const Home = () => {
  return (
  <>
  <HomeHero/>
  <HomeAbout/>
  <HomeServices/>
  <OurProduct/>
  <Section1/>
  <Testimonials/>
  <ContactForm/>
  </>
  )
}

export default Home